import getData from "@/__main__/get-data.mjs";
import { appURLs } from "@/app/constants.mjs";
import * as GraphQLTemplates from "@/game-lol/graphql-templates.mjs";
import ChampionsStats from "@/game-lol/models/lol-player-champion-stats.mjs";
import { getQueueDetails } from "@/game-lol/utils/symbol-queue.mjs";
import { getDerivedId, getDerivedQueue } from "@/game-lol/utils/util.mjs";
import { queryGQL } from "@/util/gql-formatters.mjs";

function getChampionsStats({
  region,
  profileId,
  queue,
}: {
  region: string;
  profileId: string;
  queue: string;
}) {
  return queryGQL(
    appURLs.LOL_LEAGUE_PLAYER,
    GraphQLTemplates.fetchUserChampions,
    {
      region,
      leagueProfileId: profileId,
      queue,
    },
  );
}

export default function ({
  region,
  gameName,
  tagLine,
  profileId,
  queue,
  path,
  options = {},
}: {
  region: string;
  gameName: string;
  tagLine: string;
  profileId: string;
  queue: string;
  path?: string[];
  options: object;
}) {
  if (!profileId) return;
  const derivedId = getDerivedId(region, null, gameName, tagLine);
  return getData(
    getChampionsStats({ region, profileId, queue }),
    ChampionsStats,
    path || [
      "lol",
      "playerChampionStats",
      getDerivedQueue(derivedId, getQueueDetails(queue).gql),
    ],
    {
      ...options,
    },
  );
}
